import React, { Component } from 'react'
import styled from 'styled-components'
import { Header, ImageCapture, FlexWrapper, DefaultText } from '../components'
import { IMAGE_TYPES } from 'react-html5-camera-photo'
import Cookies from 'js-cookie'
const CameraWrap = styled.div`
  height: calc(100vh - 46px);
`
const TopTitle = styled.div`
  padding: 34px 16px 16px;
  width: 100%;
  display: flex;
  justify-content: center;
`
class OrderNow extends Component {
  state = {}
  onTakePhoto = dataUri => {
    // Do stuff with the dataUri photo...
    console.log('takePhoto')
  }
  render() {
    return (
      <React.Fragment>
        <Header
          title="Scan Receipt"
          icon="arrowBack"
          onClickBack={() =>
            Cookies.get('prevPath') ? this.props.history.replace(Cookies.get('prevPath')) : this.props.history.goBack()
          }
          color="#fff"
        />
        <FlexWrapper viewPadding="0px 40px" backgroundColor="#000">
          <TopTitle>
            <DefaultText color="#fff">Capture Photo</DefaultText>
          </TopTitle>
          <CameraWrap>
            <ImageCapture
              idealResolution={{ width: 640 }}
              imageType={IMAGE_TYPES.JPG}
              imageCompression={0.97}
              isMaxResolution={false}
              isImageMirror={false}
              isDisplayStartCameraError={true}
              sizeFactor={1}
              onTakePhoto={dataUri => {
                this.onTakePhoto(dataUri)
              }}
            />
          </CameraWrap>
        </FlexWrapper>
      </React.Fragment>
    )
  }
}

export default OrderNow



// WEBPACK FOOTER //
// ./src/pages/OrderNow.js